import React, { useState } from 'react';
import { getCustomerHappinessIndexEndpoint } from 'cpfr-common';
import { useAnalyticsActionTracker } from '@cp-shared-19/frontend-ui';
import { CpDataApi } from 'cp-xhr';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import { CustomerHappinessIndexUi } from './ui/CustomerHappinessIndexUi';
import { TrustedShopsIntegrationCustomType } from '@cp-shared-19/apis';

type CustomerHappinessIndexProps = {
    firstName?: string;
    lastName?: string;
    email?: string;
    customType: TrustedShopsIntegrationCustomType;
};

const CustomerHappinessIndexWithLoadingHandler = withLoadingAndNoConnectionHandler(CustomerHappinessIndexUi);

export const CustomerHappinessIndex: React.FC<CustomerHappinessIndexProps> = ({
    firstName,
    lastName,
    email,
    customType,
}) => {
    const { onAction } = useAnalyticsActionTracker('chi');

    const [isOpeningSurvey, setIsOpeningSurvey] = useState(false);
    const [isSurveyError, setIsSurveyError] = useState(false);
    const [noEmailError, setNoEmailError] = useState(false);
    const [isConsentAccepted, setIsConsentAccepted] = useState(false);

    const handleButtonClick = (): void => {
        if (!isConsentAccepted) return;
        onAction();
        setIsOpeningSurvey(true);

        if (!email) {
            setIsOpeningSurvey(false);
            setNoEmailError(true);
            return;
        }

        const request = email
            ? {
                  firstName: firstName || '',
                  lastName: lastName || '',
                  email,
                  customType,
              }
            : undefined;

        const newWindow = window.open('', '_blank');
        CpDataApi.post(getCustomerHappinessIndexEndpoint('fr'), request)
            .then((response) => {
                setIsOpeningSurvey(false);
                if (newWindow) {
                    newWindow.location.href = response?.data?.redirectUrl;
                }
            })
            .catch(() => {
                setIsOpeningSurvey(false);
                setIsSurveyError(true);
                if (newWindow) {
                    newWindow.close();
                }
            });
    };

    if (noEmailError) return null;

    return (
        <CustomerHappinessIndexWithLoadingHandler
            isLoading={isOpeningSurvey}
            hasError={isSurveyError}
            handleButtonClick={handleButtonClick}
            isConsentAccepted={isConsentAccepted}
            setIsConsentAccepted={setIsConsentAccepted}
        />
    );
};
